module.exports = __webpack_public_path__ + "img/bungkusit.6d9827e5.png";